<template>
  <div class="title"> {{props.isForgetPwd ? "更改密码" : "设置密码" }} </div>
  <el-form>
    <el-form-item>
      <div class="relative" style="width: 100%;">
        <el-input
          v-model="formData.password"
          :type="!showPwd?'password':'text'"
          class="pwd_style "
          :class="{'pwd_text':!showPwd && formData.password}"
          placeholder="请输入8-20位密码"
          size="large"
          @focus="pwdFocusHandle"
          @blur="inputBlur"
        >
        </el-input>
        <div class="pwd_handle_box" v-if="pwdIsFocus && formData.password">
          <img @click.stop="clearPwd('pwd')" class="clear_icon point" src="@/assets/images/login/clear_icon.svg" alt="">
          <img @click.stop="showPwd = true" v-if="!showPwd" class="eye_icon point" src="@/assets/images/login/close_eye.png" alt="">
          <img @click.stop="showPwd = false" v-if="showPwd" class="eye_icon point" src="@/assets/images/login/open_eye.png" alt="">
        </div>
      </div>
    </el-form-item>

    <el-form-item>
      <div class="relative" style="width: 100%;">
        <el-input
          v-model="formData.repassword"
          :type="!showRePwd?'password':'text'"
          :class="{'pwd_text':!showRePwd && formData.repassword}"
          placeholder="请再次输入密码"
          size="large"
          class="pwd_style"
          @focus="repwdFocusHandle"
          @blur="inputBlur"
        >
        </el-input>
        <div class="pwd_handle_box" v-if="repwdIsFocus && formData.repassword">
          <img @click.stop="clearPwd('repwd')" class="clear_icon point" src="@/assets/images/login/clear_icon.svg" alt="">
          <img @click.stop="showRePwd = true" v-if="!showRePwd" class="eye_icon point" src="@/assets/images/login/close_eye.png" alt="">
          <img @click.stop="showRePwd = false" v-if="showRePwd" class="eye_icon point" src="@/assets/images/login/open_eye.png" alt="">
        </div>
      </div>
    </el-form-item>

    <el-button
      class="submit-btn"
      size="large"
      type="primary"
      text
      bg
      @click="confirmHandle"
      >确认</el-button
    >

    <div style="text-align: center;" class="mgt12" v-if="props.nexSetingShow">
      <el-button link @click="setUpLater">稍后设置</el-button>
    </div>
  </el-form>
  <!-- 没点击同意协议 -->
  <agreementHandle ref="agreeModel" @canLogin="agreeHandle"/>
</template>
      
<script setup>
import { ref, onMounted, reactive, onBeforeUnmount } from "vue";
import { useLoginStore } from './store';
import requestApi from "@/api/index";
import agreementHandle from './agreementHandle.vue'; //
import { messageError, messageSuccess } from "@/utils/message";
const props = defineProps(['hasBack','nexSetingShow','isForgetPwd'])
const loginStore = useLoginStore();
const agreeModel = ref(null);
const emits = defineEmits(['onLoginSuccess','closeDialog','to', 'focus', 'blur']);
const formData = reactive({
  password:'',
  repassword:'',
  phone: '', //手机号码
  zoneNum: '', //手机号码区号
  needType: 'pwd', //校验类型
  verifyCode:'', //验证码
  agreementCheckOut: false
})

const pwdIsFocus = ref(false);//密码是否聚焦
const repwdIsFocus = ref(false);//更改密码是否聚焦

const showPwd = ref(false);

const showRePwd = ref(false);

// 清空密码
const clearPwd = (val) =>{
  if(val == 'pwd'){
    formData.password = '';
  }else if(val == 'repwd'){
    formData.repassword = '';
  }
}

// 
const pwdFocusHandle = () =>{
  pwdIsFocus.value = true;
  emits('focus')
}

// 
const repwdFocusHandle = () =>{
  repwdIsFocus.value = true;
  emits('focus')
}

const inputBlur = () =>{
  emits('blur')
}

// 同意并执行下一步
const agreeHandle = () =>{
  formData.agreementCheckOut = true;
  loginStore.changeAgreementCheck(true)
  bus.emit('changeAgreement', true)
  confirmHandle();
}
  
// 稍后设置
const setUpLater = () =>{
  location.reload();
  emits('closeDialog')
}

const settingInit =() => {
  formData.phone = loginStore.phoneNumber;
  formData.verifyCode = loginStore.verifyCode;
  formData.zoneNum = loginStore.phoneZone;
  formData.agreementCheckOut = loginStore.agreementCheckOut;
}

// 校验两个密码是否一样
const validatePwd = () => {
  if(formData.password == ''){
    messageError('请输入密码', 40)
    return false
  }
  if(formData.repassword == ''){
    messageError('请再次输入密码', 40)
    return false
  }
  if(formData.password.length > 20 || formData.password.length < 8){
    messageError('请输入8-20位密码', 40)
    return false
  }
  if(formData.password != formData.repassword){
    messageError('两次输入密码不一样', 40)
    return false
  }
  return true
}

// 确认
const confirmHandle = () => {
  if (validatePwd() == false) {
    return false;
  }
  
  if(props.isForgetPwd){ //忘记密码
    requestApi.loginModule
    .changeForgetPassword({
      phone: formData.phone,
      zoneNum: formData.zoneNum.replace(/[^\d]/g, ''),
      password: formData.password,
      verifyCode: formData.verifyCode
    })
    .then((response) => {
      const result = response.data;
      console.log(result);
      if (result.code == 200) {
        messageSuccess('密码已修改请重新登录', 40)
        emits('to',{
          model:'VccLoginForm',
          hasBack:false,
          hasAgreement:true,
          isForgetPwd:false
        })
      } else {
        let errMsg = result.msg != undefined ? result.msg : "系统错误";
        messageError(errMsg, 40);
        return false;
      }
    }).catch(reason => {
      console.error(reason);
      messageError(reason, 40);
    });
  }else if(props.nexSetingShow){ //设置密码
    if(!formData.agreementCheckOut){
      agreeModel.value.agreeShow = true;
      return false;
    }
    requestApi.loginModule
    .userSetPwd({
      pwd: formData.password
    })
    .then((response) => {
      const result = response.data;
      console.log('设置密码',result);
      if (result.code == 200) {
        messageSuccess('密码设置成功', 40);
        location.reload();
        emits('closeDialog',true)
      } else {
        let errMsg = result.msg != undefined ? result.msg : "系统错误";
        messageError(errMsg, 40);
        return false;
      }
    }).catch(reason => {
      console.error(reason);
      messageError(reason, 40);
    });
  }else{
    if(!formData.agreementCheckOut){
      agreeModel.value.agreeShow = true;
      return false;
    }
    requestApi.loginModule
    .doRegister({
      phone: formData.phone,
      zoneNum: formData.zoneNum.replace(/[^\d]/g, ''),
      needType: formData.needType,
      password: formData.password,
      verifyCode: formData.verifyCode
    })
    .then((response) => {
      const result = response.data;
      console.log(result);
      if (result.code == 200) {
        const access = result.data.accessInfo;
        emits('onLoginSuccess',access,formData.phone,formData.zoneNum,false,true)
      } else {
        let errMsg = result.msg != undefined ? result.msg : "系统错误";
        messageError(errMsg, 40);
        return false;
      }
    }).catch(reason => {
      console.error(reason);
      messageError(reason, 40);
    });
  }
}

const enterKeyDown = (event) =>{
  if(event.key == 'Enter'){
    confirmHandle();
  }
}

onMounted(()=>{
  settingInit();
  document.addEventListener('keydown', enterKeyDown)
})

onBeforeUnmount(()=> {
  document.removeEventListener('keydown', enterKeyDown);
})

// defineExpose({});
</script>

<style lang="scss" scoped>
  @import url(./styles/index.scss);
  .submit-btn {
    --el-button-hover-text-color: #ffffff;
    width: 100%;
    border-radius: 25px;
    font-size: 16px;
    height: 48px;
  }
  .pwd_handle_box{
    position: absolute;
    right: 16px;
    top: 14px;
    z-index: 9;
    .clear_icon{
      width: 20px;
      height: 20px;
    }
    .eye_icon{
      width: 20px;
      height: 20px;
      margin-left: 12px;
    }
  }
</style>